import kylogger from '../../../log/kylogger';
import isInKwaiying from '../../../isInKwaiying';
import { OperateReport } from '../../../reportError';
import { Platform } from 'react-native';
const report = new OperateReport('request');
export const logTime = ({ status, url, useNative, config, time, message, errorType, }) => {
    // passToken不合规，去除
    const headers = { ...config?.headers };
    delete headers.passToken;
    const _config = { ...config, headers };
    isInKwaiying() &&
        kylogger.getLogger().then((logger) => {
            logger?.collect?.('CLICK', 'KY_KRN_NETWORK_PRE_REQUEST', {
                statusName: status,
                url,
                useNative: useNative ? 1 : 0,
                config: JSON.stringify(_config || {}),
                time,
                message,
                errorType,
            });
        });
};
export async function request(config, next) {
    config.startTime = Date.now();
    const { url } = config;
    config.report = report.start({
        subBusiness: config?.useNativeRequest
            ? 'native'
            : Platform.OS === 'web'
                ? 'xhr'
                : 'fetch',
        group: url,
    });
    logTime({
        status: 'requestStart',
        url,
        config: config,
        useNative: config?.useNativeRequest,
    });
    await next();
    config.report?.progress('configReady');
    config.fetchReqCompleteTime = Date.now();
}
export const response = [
    function (response) {
        const { status, config, data } = response;
        const { url } = config;
        config.endTime = Date.now();
        const time = config?.startTime
            ? config.endTime - Number(config?.startTime)
            : -1;
        const isSuccess = status === 200 &&
            data &&
            (data.result === 1 ||
                data.message === 'SUCCESS' ||
                data.status === 0);
        if (isSuccess) {
            logTime({
                status: 'requestSuccess',
                url,
                config: config,
                useNative: config?.useNativeRequest,
                time,
            });
            config.report?.success();
            return data;
        }
        else {
            logTime({
                status: 'requestError',
                url: url,
                config: config,
                useNative: config?.useNativeRequest,
                errorType: status !== 200 ? 'status_fail' : 'server_error',
                time,
                message: status !== 200 ? response : data,
            });
            const error = status === 200
                ? data || new Error('unknown error')
                : new Error('error.weakNet');
            config.report?.fail(error, config?.ignoreErrorReport?.(response) ?? false, config);
            throw error;
        }
    },
    (err) => {
        // fetch adaper部分返回的是Error对象，不是AxiosError对象。导致获取不到config
        const { response, config } = err;
        const { data } = response || {};
        const now = Date.now();
        const time = config?.startTime ? now - Number(config?.startTime) : -1;
        if (config) {
            config.endTime = now;
        }
        logTime({
            status: 'requestError',
            url: config?.url,
            config: config,
            useNative: config?.useNativeRequest,
            errorType: 'status_fail',
            time,
        });
        // rn中bridge的调用，不提前序列化AxiosError对象会报错，所以简化一下。
        const returnErr = {
            message: err.message?.startsWith('Error Domain=') // 方便错误信息聚合
                ? 'network error'
                : err.message || data?.message || 'network error',
            stack: err.stack,
        };
        config?.report?.fail(returnErr, false, config);
        throw returnErr;
    },
];
